import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * React to the sidebar's quick "+" (B3, feedback round 3).
 *
 * The "+" navigates to `<page>?add=true`. Pages used to read that ONCE - in a
 * useState initialiser or a mount-only effect - so pressing "+" while already
 * on the page (the common case: "+" sits on the active row) changed the URL
 * and nothing else. This runs every time the signal appears: it strips
 * `add` from the URL (so Back or a refresh does not reopen the form) and then
 * calls `onAdd`. `ready` defers it until the page can open its form (My time
 * waits for its matter list).
 */
export function useAddSignal(onAdd: () => void, ready: boolean = true): void {
  const location = useLocation();
  const history = useHistory();
  const onAddRef = useRef(onAdd);
  onAddRef.current = onAdd;

  useEffect(() => {
    if (!ready) return;
    const params = new URLSearchParams(location.search);
    if (params.get('add') !== 'true') return;
    params.delete('add');
    const search = params.toString();
    history.replace({ pathname: location.pathname, search: search ? `?${search}` : '', hash: location.hash });
    onAddRef.current();
  }, [location.search, location.pathname, location.hash, ready, history]);
}

export default useAddSignal;
